<template>
<div>
  <b-modal ref="projectsManagerModalRef" id="projectsManagerModalRef" :hide-footer="true" title="Selecione um projeto para replicar os dados de Gestor" size="lg" :hide-header="false">
    <div class="modal-projects-list">
      <div v-if="loadingProjects">
        <h6>Aguarde, carregando projetos...</h6>
      </div>
      <ul v-else>
        <li v-for="p in projects" v-bind:key="p.ProjectId">
          <a v-if="p.Manager" href="#" v-on:click.stop.prevent="selectProjectManager(p)">
            <span>{{(p.Info) ? p.Info.title : 'Sem Título'}}</span>
              <p>Nome Completo: {{p.Manager.name}}</p>
              <p>Organização: {{p.Manager.organization}}</p>
          </a>
          <a href="#" v-else v-on:click.stop.prevent="showAlert()">
            <span>{{(p.Info) ? p.Info.title : 'Sem Título'}}</span>
              <p>Projeto não possui gestor cadastrado.</p>
          </a>
        </li>
      </ul>
    </div>
  </b-modal>
  <div class="row" v-if="projects && projects.length > 0">
    <div class="col-md-8"></div>
    <div class="col-md-4">
      <button v-b-modal.projectsManagerModalRef class="btn">Copiar de outro projeto</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <h4>Gestor</h4>
      <span>Preencha com os dados do gestor de sua Organização Social.</span>
      <span>Esses dados devem coincidir com os dados bancários e cadastro nos meios de pagamento (Paypal e Pagseguro).</span>
    </div>

    <div class="col-md-8">
      <form>
        <div class="row">
          <div class="form-group col-sm">
            <label>Nome completo</label>
            <input type="text" class="form-control" v-model="name"/>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-sm">
            <label>Nome da organização</label>
            <input type="text" class="form-control" v-model="organization"/>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-sm">
            <label>Telefone fixo</label>
            <input type="text" class="form-control" v-model="phone"/>
          </div>
          <div class="form-group col-sm">
            <label>Telefone móvel</label>
            <input type="text" class="form-control" v-model="celphone"/>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-sm">
            <label>Endereço</label>
            <input type="text" class="form-control" v-model="address"/>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-sm">
            <label>Bairro</label>
            <input type="text" class="form-control" v-model="hood"/>
          </div>
          <div class="form-group col-sm">
            <label>Cidade</label>
            <input type="text" class="form-control" v-model="city"/>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-sm">
            <label>País</label>
            <input type="text" class="form-control" v-model="country"/>
          </div>
          <div class="form-group col-sm">
            <label>CEP</label>
            <input type="text" class="form-control" v-model="cep"/>
          </div>
        </div>
        
      </form>
    </div>
  </div>
  <div class="row">
      <div class="col-md-4">
        <button @click.stop.prevent="save()" class="btn">Salvar Alterações</button>
      </div>
      <div class="col-md-8">
        <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{msg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" @click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
          {{successMsg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" @click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'

export default {
  name: 'ProjectManager',
  props: ['project'],
  components: {

  },
  data(){
    return {
      msg: '',
      successMsg: '',
      showMsg: false,
      showSuccessMsg: false,
      loadingProjects: true,
      projects: null,
      projectId: null,
      name: null,
      organization: null,
      phone: null,
      celphone: null,
      address: null,
      hood: null,
      city: null,
      country: null,
      cep: null,
      page: 'manager'
    }
  },
  mounted (){
    this.projectId = this.project.ProjectId;
    if(this.project.Manager){
      this.name = this.project.Manager.name;
      this.organization = this.project.Manager.organization;
      this.phone = this.project.Manager.phone;
      this.celphone = this.project.Manager.celphone;
      this.address = this.project.Manager.address;
      this.hood = this.project.Manager.hood;
      this.city = this.project.Manager.city;
      this.country = this.project.Manager.country;
      this.cep = this.project.Manager.cep;
    }
    this.getProjects();
  },
  methods: {
    getProjects(){
      this.$http.get(API.Profile.projects, {headers: auth.getHeaders()}).then((result) => {
        this.loadingProjects = false;
        this.projects = result.body.projects
        if(this.projects){
          var projectId = this.projectId
          this.projects = this.projects.filter((p) => {
            return p.ProjectId != projectId
          })
        }
      });
    },
    selectProjectManager(p){
      this.$refs.projectsManagerModalRef.hide();
      if(p.Manager){
        this.name = p.Manager.name;
        this.organization = p.Manager.organization;
        this.phone = p.Manager.phone;
        this.celphone = p.Manager.celphone;
        this.address = p.Manager.address;
        this.hood = p.Manager.hood;
        this.city = p.Manager.city;
        this.country = p.Manager.country;
        this.cep = p.Manager.cep;
      }
    },
    save(){
      this.$emit('showloading');
      this.showMsg = false;
      this.showSuccessMsg = false;
      if(this.validate()){
        this.$http.post(API.Projects.updateProject + this.projectId, {page: this.page, name: this.name, organization: this.organization, phone: this.phone, celphone: this.celphone,
          address: this.address, hood: this.hood, city: this.city, country: this.country, cep: this.cep}, {headers: auth.getHeaders()}).then((res) => {
            if(res.body.success === true){
              this.successMsg = res.body.message;
              this.showSuccessMsg = true;
              this.$emit('reload');
            }else{
              this.showMessage(res.body.message);
            }
            this.$emit('hideloading');
          }, (err) => {
            this.showMessage('Erro ao processar requisição.');
            this.$emit('hideloading');
          });
      }else{
        this.$emit('hideloading');
      }
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    },
    showAlert(){
      alert("Projeto não possui gestor cadastrado!");
    },
    validate(){
      if(this.name == '' || this.name == null){
        this.showMessage("Insira o nome do(a) responsável.");
        return false;
      }
      if(this.organization == '' || this.organization == null){
        this.showMessage("Insira a Organização do(a) responsável.");
        return false;
      }
      if(this.phone == '' || this.phone == null){
        this.showMessage("Insira o telefone do(a) responsável ou da Organização.");
        return false;
      }
      if(this.address == '' || this.address == null || this.hood == '' || this.hood == null || 
        this.city == '' || this.city == null || this.country == '' || this.country == null || this.cep == '' || this.cep == null){
        this.showMessage("Insira o endereço completo do(a) responsável.");
        return false;
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.modal-projects-list{
  ul{
    list-style: none;
    padding: 0px;
    li{
      border: thin solid #ccc;
      border-radius: 10px;
      margin-top: 20px;
      &:first-child{
        margin-top: 0px;
      }
      a{
        text-decoration: none;
        color: #666;
        display: block;
        padding: 10px;

        span{
          font-weight: bold;
          font-size: 22px;
        }
      }
      &:hover{
        border: thin solid #00AE39;
        a{
          color: #00AE39;
          font-weight: bold;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/Manager.vue